// 保存データを画像に埋め込む・画像から読む（2026-10-24〜、FINISH-PARTS.md の F3 で1つに。前は完成画面の共通部品 additional.js と、
// 新しい作る画面の download.ts・importimage.ts に同じものがそれぞれあった）。
// 決まり: 左上の画素から順に1ビットずつ、「[START] + 文字 + [END]」を 1 文字 8 ビットで。不透明な画素は赤の最下位ビット、
// 透明・半透明の画素は不透明度の最下位ビット（2026-10-16〜。読む側の各 restore.php も同じ決まり。前の白い背景の画像は全部不透明なので今までどおり読める）

export function embedText(canvas: HTMLCanvasElement, context: CanvasRenderingContext2D, text: string) {
  const bits = ('[START]' + text + '[END]')
    .split('')
    .map((c) => c.charCodeAt(0).toString(2).padStart(8, '0'))
    .join('');
  const data = context.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = data.data;
  for (let i = 0; i < bits.length; i++) {
    // 透明・半透明の画素は、ブラウザの中で色が不透明度を掛けた形で持たれるので、赤の最下位ビットが保てない
    // （透過の高画質DL から復元できなかった）。そういう画素は不透明度の最下位ビットに入れる（不透明度はそのまま保たれ、±1 は見えない）
    let alpha = pixels[i * 4 + 3];
    if (alpha < 255) {
      alpha = (alpha & ~1) | (bits[i] === '1' ? 1 : 0);
      pixels[i * 4 + 3] = alpha === 255 ? 253 : alpha; // 255 にすると不透明として赤から読まれるので 253 に
    } else if (bits[i] === '1') pixels[i * 4] |= 1;
    else pixels[i * 4] &= ~1;
  }
  context.putImageData(data, 0, 0);
}

// 埋め込んだ文字（[START] と [END] の間）を読む。無ければ null。
// 左上の画素から1文字（8画素）ずつ読み、先頭が [START] でなければ CHARAT の画像ではないのでそこでやめ、[END] まで読んだら止める
// （以前は画像の全画素を文字にしてから探していて、大きな画像ほど重かった。2026-10-08）
export function readEmbeddedText(img: HTMLImageElement): string | null {
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext('2d', { willReadFrequently: true })!;
  ctx.drawImage(img, 0, 0);
  const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  let text = '';
  for (let p = 0; (p + 8) * 4 <= pixels.length; p += 8) {
    let code = 0;
    for (let k = 0; k < 8; k++) code = (code << 1) | (pixels[(p + k) * 4 + 3] < 255 ? pixels[(p + k) * 4 + 3] & 1 : pixels[(p + k) * 4] & 1); // 不透明なら赤、そうでなければ不透明度
    text += String.fromCharCode(code);
    if (text.length === 7 && text !== '[START]') return null;
    if (text.length > 7 && text.endsWith('[END]')) return text.slice(7, -5);
    if (text.length > 4000000) return null;
  }
  return null;
}
